module.exports = __webpack_public_path__ + "static/media/pagesix.com_2016_09_20_angelina-dumped-brad-after-private-eye-uncovered-marion-cotillard-affair__plot.d2ed7685.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/pagesix.com_2016_09_20_angelina-dumped-brad-after-private-eye-uncovered-marion-cotillard-affair__plot.png
// module id = 414
// module chunks = 0